import unitsSlice from './unitsSlice';

export * from './thunks';

export default unitsSlice;
